import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import { useSelector } from "react-redux";
import { test } from "redux-store/lab-tests/tests.selecter";

type Props = {
  open: boolean;
  handleClose: () => void;
  petId: any;
};

const PetPurchaseDetailModal = ({ open, handleClose, petId }: Props) => {
  const tests = useSelector(test);

  // Find the matching test for the petId
  const matchedTest = tests?.find((t: any) => t.petId?._id === petId);

  const labels = ["E-commerce Store", "Vet Clinics", "Pet Supply Stores", "Pet Insurance", "Pet Televet"];

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="pet-purchase-details" fullWidth>
      <DialogTitle id="pet-purchase-details">
        <p className="tw-text-[#FF7B6D] tw-font-semibold">Pet Purchase Details</p>
        <div className="tw-w-full tw-border-b-2 mt-2"></div>
      </DialogTitle>
      <DialogContent>
        <div className="tw-flex tw-flex-col tw-gap-4 tw-p-4">
          {matchedTest && matchedTest.kitId?.purchaseDetails ? (
            Object.entries(matchedTest.kitId.purchaseDetails)
              .filter(([_, value]) => (value as { checked: boolean; reason: string })?.checked)
              .map(([key, value], index) => {
                const typedValue = value as { checked: boolean; reason: string };
                return (
                  <div key={key} className="tw-flex tw-justify-between tw-items-center">
                    <span className="tw-font-bold">{labels[index] || key}:</span>
                    <span>{typedValue.reason || "No reason provided"}</span>
                  </div>
                );
              })
          ) : (
            <p className="tw-text-center tw-text-gray-600">No purchase details available for this pet.</p>
          )}
        </div>
        <div className="tw-w-full tw-flex tw-justify-end mt-4">
          <button onClick={handleClose} className="tw-bg-[#FF7B6D] tw-text-white tw-px-5 tw-py-2 tw-rounded-md">
            Close
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PetPurchaseDetailModal;
